module.exports = __webpack_public_path__ + "img/ROUND.47b7b40d.png";